import Dialog from '@zenbusiness/zui/Dialog';
import DialogContentText from '@zenbusiness/zui/DialogContentText';
import { styled } from '@zenbusiness/zui/styles';

export const DialogStyled = styled(Dialog)(() => ({
  '& .MuiDialog-container .MuiPaper-root': {
    borderRadius: '20px',
    margin: '20px',
    width: 'calc(100% - 40px)'
  }
}));

export const DialogHeaderStyled = styled('div')(() => ({
  padding: '24px 24px 8px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const DialogContentTextStyled = styled(DialogContentText)(() => ({
  padding: '0 24px 24px 24px'
}));
